<template>
	<aside class="key-takeaways-module p-200 my-200">
		<p class="heading-6 heading-5-lg mb-100">Key Takeaways</p>
		<ul class="body-md ul">
			<li v-for="(takeaway, index) in keyTakeaways" :key="index">
				<strong v-if="takeaway.heading" class="font-weight-bold display-block">{{ takeaway.heading }}</strong>
				<span v-html="takeaway.summary"></span>
			</li>
		</ul>
	</aside>
</template>

<script setup lang="ts">
import { SanityKeyTakeaway } from 'types/sanity/blog-education-center';

interface Props {
	keyTakeaways: Array<SanityKeyTakeaway>;
}

withDefaults(defineProps<Props>(), {
	keyTakeaways: () => []
});
</script>

<style scoped lang="scss">
@use '../../styles/constants/colors' as *;

.key-takeaways-module {
	border: solid 1px gray(30);
	border-radius: 3px;

	.article-body > &:first-child {
		margin-top: 0;
	}

	h2 {
		margin-bottom: 1rem;
	}

	.ul li {
		+ li {
			margin-top: 0.5rem;
		}
	}
}
</style>
